import { render } from "./RestoAdd.vue?vue&type=template&id=662141e0"
import script from "./RestoAdd.vue?vue&type=script&lang=js"
export * from "./RestoAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__